import { Reveal } from "../components/Reveal";
import useSeo from "../lib/useSeo";
import ObfuscatedEmail from "../components/ObfuscatedEmail";

const SECTIONS = [
  {
    title: "Introduction",
    body: [
      "This website and all services provided by IntoLaw, a division of Praxio (Pty) Ltd, are intended for general information, legal consulting and document preparation purposes only.",
    ],
  },
  {
    title: "No Professional Legal Advice",
    body: [
      "The information, documents and services available through this website do not constitute professional legal advice.",
      "Users should consult a suitably qualified and admitted legal practitioner where formal legal advice is required for their specific circumstances.",
    ],
  },
  {
    title: "No Attorney-Client Relationship",
    body: [
      "Use of this website or our services does not establish an attorney-client relationship.",
      "No such relationship exists unless a separate written engagement agreement has been concluded with an admitted legal practitioner.",
    ],
  },
  {
    title: "Limitation of Liability",
    body: [
      "To the fullest extent permitted by South African law, IntoLaw, Praxio (Pty) Ltd, its directors, employees, contractors and representatives shall not be liable for any direct, indirect or consequential loss, damage, cost or expense arising from reliance upon this website, our services or any documents prepared.",
    ],
  },
  {
    title: "Accuracy of Information",
    body: [
      "Although every reasonable effort is made to maintain accurate and current information, laws frequently change.",
      "Accordingly, no guarantee is provided regarding the completeness, accuracy or continued currency of information published on this website.",
    ],
  },
  {
    title: "PAIA and POPIA",
    body: [
      "Our PAIA Manual and POPIA Policy are available upon request.",
      "Requests made in terms of the Promotion of Access to Information Act (PAIA) or the Protection of Personal Information Act (POPIA) should be directed to our Information Officer.",
    ],
    contact: { label: "Information Officer", user: "info", domain: "praxio.co.za" },
  },
  {
    title: "General Enquiries",
    body: ["Service-related enquiries should be directed to:"],
    contact: { label: "General Enquiries", user: "intolaw", domain: "praxio.co.za" },
  },
  {
    title: "Physical Address",
    body: ["31 5th Street", "Commercia", "Midrand", "1685", "South Africa"],
  },
  {
    title: "ECTA",
    body: [
      "This website complies with the Electronic Communications and Transactions Act (ECTA) of South Africa.",
      "Electronic communications and electronic transactions conducted through this website are governed by applicable South African legislation.",
    ],
  },
  {
    title: "Governing Law",
    body: [
      "These Terms and all use of this website shall be governed by the laws of the Republic of South Africa.",
    ],
  },
  {
    title: "Final Acknowledgement",
    body: [
      "By accessing or using this website, users acknowledge that they have read, understood and accepted these Terms and Conditions and all applicable disclosures.",
    ],
  },
];

export default function Terms() {
  useSeo({
    title: "Terms and Conditions / Disclosures",
    description:
      "Terms and Conditions and legal disclosures for IntoLaw, a division of Praxio (Pty) Ltd, including PAIA/POPIA, ECTA and governing law.",
    path: "/terms",
  });

  return (
    <section className="px-6 pt-40 pb-24 lg:px-10 lg:pt-48">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-gold">Legal</p>
          <h1 className="font-display text-4xl font-semibold leading-tight tracking-tight text-navy sm:text-5xl lg:text-6xl">
            Terms and Conditions / Disclosures
          </h1>
        </Reveal>

        <div className="mt-14 space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={0.02 * i}>
              <div>
                <h2 className="font-display text-2xl font-medium text-navy lg:text-3xl">{s.title}</h2>
                <div className="mt-4 space-y-3 leading-relaxed text-slate-600">
                  {s.body.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                  {s.contact && (
                    <p className="pt-1">
                      <span className="font-medium text-navy">{s.contact.label}: </span>
                      <ObfuscatedEmail
                        user={s.contact.user}
                        domain={s.contact.domain}
                        className="text-royal underline decoration-gold/40 underline-offset-4 hover:text-gold transition-colors"
                        data-testid={`terms-email-${s.contact.user}`}
                      />
                    </p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
